/*
 * @Author: panweikang
 * @Date: 2024-01-04 15:13:14
 * @LastEditTime: 2024-07-15 22:56:14
 * @Description:
 */
import './mineReport.scss'
import logo from '../../static/report/logo.png'
import relieblePng from '../../static/mine/relieble.png'
import baogaoPng from '../../static/mine/baogao.png'
import jinnangPng from '../../static/mine/jinnang.png'
import pintuanPng from '../../static/mine/pintuan.png'
import kefuPng from '../../static/mine/kefu.png'
import MFooter from '../../components/MFooter/index'
import { Avatar, List, Space, Image } from 'antd-mobile'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import wxConfig from '../../utils/wxConfig'
import MHead from '../../components/MHead/index'

let MineReport = () => {
  // document.title = '我的报告'
  document.title = '瑞莱博2023年物流地产年度报告'
  let userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}')

  useEffect(() => {
    if (userInfo.openId) {
      wxConfig(userInfo.openId)
    }
  }, [])

  let navigate = useNavigate()
  let goHome = () => {
    navigate(`/rlb/YearMiddleReport2024/1`)
  }
  // 打开客服
  let openKF = () => {
    window.open('https://work.weixin.qq.com/kfid/kfcae5d692a85157520')
  }
  return (
    <div className="mineReport">
      <MHead />
      <div className="pageContent">
        <div className="userInfo">
          <Space block wrap>
            <Avatar style={{ '--size': '32px' }} src={userInfo.headImgUrl} alt="avatar" />
            <p className="userName">{userInfo.nickName}</p>
          </Space>
        </div>
        <div className="list">
          <List>
            {/* <List.Item
              prefix={<Image src={jinnangPng} fit="cover" width={22} height={22} />}
              extra="邀请好友集锦囊"
              onClick={() => {
                navigate('/rlb/YearEndReport/invitation')
              }}
            >
              报告锦囊
            </List.Item> */}
            <List.Item
              prefix={<Image src={pintuanPng} fit="cover" width={22} height={22} />}
              extra="邀请好友一起拼"
              onClick={() => {
                navigate('/rlb/YearMiddleReport2024/GroupRecords')
              }}
            >
              拼团享优惠
            </List.Item>
            <List.Item
              prefix={<Image src={baogaoPng} fit="cover" width={22} height={22} />}
              extra="查看报告"
              onClick={() => {
                navigate('/rlb/YearEndReport/bought')
              }}
            >
              已购报告列表
            </List.Item>
            <List.Item
              prefix={<Image src={relieblePng} fit="cover" width={22} height={22} />}
              extra="了解更多"
              onClick={() => {
                navigate('/rlb/YearEndReport/about')
              }}
            >
              关于瑞莱博
            </List.Item>
            <List.Item
              prefix={<Image src={kefuPng} fit="cover" width={22} height={22} />}
              extra="咨询/商务合作"
              onClick={openKF}
            >
              在线客服
            </List.Item>
          </List>
        </div>
      </div>
      <MFooter />
    </div>
  )
}

export default MineReport
